import React from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import CardRow from 'design-system/CardRow';
import { Avatar } from 'design-system/avatar';
import CardRowContainer from 'design-system/CardRowContainer';
import useColors from 'hooks/useColors';
import { formatAmount, formatSortCode } from 'utils/formatting';
import { AccountTypeDisplayLong, transferProductString } from '../constants';
const strings = {
    providerLabel: (t) => t === 'JISA' ? `${AccountTypeDisplayLong[t]} provider` : 'ISA provider',
    accountReferenceLabel: 'Account reference',
    accountNumberLabel: 'Account number',
    balanceLabel: (t) => (t === 'JISA' ? 'Junior ISA balance' : 'ISA total balance'),
    accountType: 'Account type',
    sortCode: 'Sort code',
};
const ProductTransferDetails = ({ type, balance, accountType, hideBalance, providerName, providerLogoUrl, identification, }) => {
    const colors = useColors();
    return (<CardRowContainer>
      <CardRow small tableSpacing title={strings.providerLabel(accountType)} info={providerLogoUrl ? (<View style={styles.providerInfo}>
              <Text Text-14 numberOfLines={1} flex right>
                {providerName}
              </Text>
              <Avatar imageUrl={providerLogoUrl} name={providerName} size={24} color={colors.background.brandLight} fontColor={colors.text.textOnBrand}/>
            </View>) : (providerName)}/>
      <CardRow small tableSpacing title={strings.accountType} info={`${accountType === 'JISA' ? 'Junior' : ''}${type ? ` ${transferProductString[type]}` : ''} ${accountType}`}/>
      {'accountReference' in identification ? (<CardRow small tableSpacing title={strings.accountReferenceLabel} info={identification.accountReference}/>) : (<>
          <CardRow small tableSpacing title={strings.sortCode} info={formatSortCode(identification.previousProviderSortCode)}/>
          <CardRow small tableSpacing title={strings.accountNumberLabel} info={identification.previousProviderAccountNumber}/>
        </>)}
      {!hideBalance && (<CardRow small tableSpacing title={strings.balanceLabel(accountType)} info={formatAmount(balance, 'GBP', 2)}/>)}
    </CardRowContainer>);
};
export default React.memo(ProductTransferDetails);
const styles = StyleSheet.create({
    providerInfo: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(8),
    },
});
